const Swiper = require('swiper/bundle').default;

/**
 * Testimonial carousel (single slide, prev/next arrows).
 */
module.exports = function initTestimonials() {
	document.querySelectorAll('.testimonials__swiper').forEach((container) => {
		const section = container.closest('.testimonials');
		const slides = container.querySelectorAll('.swiper-slide');
		const count = slides.length;

		if (count === 0) {
			return;
		}

		const prefersReduced =
			typeof window.matchMedia === 'function' &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (prefersReduced) {
			if (section) {
				section.classList.add('testimonials--reduced');
			}
			return;
		}

		const loop = count > 1;

		new Swiper(container, {
			loop,
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 450,
			watchOverflow: true,
			navigation: {
				nextEl: container.querySelector('.swiper-button-next'),
				prevEl: container.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: container.querySelector('.swiper-pagination'),
				clickable: true,
			},
			a11y: {
				enabled: true,
			},
		});
	});
};
